<template>
    <div class="progress">
        <div class="progress-bar" :style="barStyle"/>
        <div class="progress-number" :style="numberStyle">
            <svg width="50" height="41" viewBox="0 0 50 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_784:6949" fill="white">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29627 0.715088C2.53484 0.715088 0.296265 2.95366 0.296265 5.71509V32.7151C0.296265 35.4765 2.53485 37.7151 5.29627 37.7151H21.7173L24.438 40.4358L27.1587 37.7151H44.8447C47.6061 37.7151 49.8447 35.4765 49.8447 32.7151V5.71509C49.8447 2.95366 47.6061 0.715088 44.8447 0.715088H5.29627Z"/>
            </mask>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29627 0.715088C2.53484 0.715088 0.296265 2.95366 0.296265 5.71509V32.7151C0.296265 35.4765 2.53485 37.7151 5.29627 37.7151H21.7173L24.438 40.4358L27.1587 37.7151H44.8447C47.6061 37.7151 49.8447 35.4765 49.8447 32.7151V5.71509C49.8447 2.95366 47.6061 0.715088 44.8447 0.715088H5.29627Z" fill="white"/>
            <path d="M21.7173 37.7151L22.4244 37.008L22.1315 36.7151H21.7173V37.7151ZM24.438 40.4358L23.7309 41.1429L24.438 41.85L25.1451 41.1429L24.438 40.4358ZM27.1587 37.7151V36.7151H26.7444L26.4515 37.008L27.1587 37.7151ZM1.29626 5.71509C1.29626 3.50595 3.08713 1.71509 5.29627 1.71509V-0.284912C1.98256 -0.284912 -0.703735 2.40138 -0.703735 5.71509H1.29626ZM1.29626 32.7151V5.71509H-0.703735V32.7151H1.29626ZM5.29627 36.7151C3.08713 36.7151 1.29626 34.9242 1.29626 32.7151H-0.703735C-0.703735 36.0288 1.98256 38.7151 5.29627 38.7151V36.7151ZM21.7173 36.7151H5.29627V38.7151H21.7173V36.7151ZM25.1451 39.7286L22.4244 37.008L21.0102 38.4222L23.7309 41.1429L25.1451 39.7286ZM26.4515 37.008L23.7309 39.7286L25.1451 41.1429L27.8658 38.4222L26.4515 37.008ZM44.8447 36.7151H27.1587V38.7151H44.8447V36.7151ZM48.8447 32.7151C48.8447 34.9242 47.0538 36.7151 44.8447 36.7151V38.7151C48.1584 38.7151 50.8447 36.0288 50.8447 32.7151H48.8447ZM48.8447 5.71509V32.7151H50.8447V5.71509H48.8447ZM44.8447 1.71509C47.0538 1.71509 48.8447 3.50595 48.8447 5.71509H50.8447C50.8447 2.40138 48.1584 -0.284912 44.8447 -0.284912V1.71509ZM5.29627 1.71509H44.8447V-0.284912H5.29627V1.71509Z" fill="#E1E1E1" mask="url(#path-1-inside-1_784:6949)"/>
            </svg>
            <span>{{formatedNumber}}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        progress: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
        }
    },
    computed: {
        barStyle() {
            return {
                width: this.formatedNumber
            }
        },
        numberStyle() {
            return {
                left: this.formatedNumber
            }
        },
        formatedNumber() {
            return Math.round(this.progress * 100) + '%'
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.progress
    width 320px
    border 1px solid #E1E1E1
    box-sizing border-box
    border-radius 12px
    background-color white
    position relative
    height 12px

    .progress-bar
        height 100%
        width 0
        border-radius inherit
        background repeating-linear-gradient(270deg, #72E7AF 0%, #137CFC 50%, #72E7AF 100%)
        animation progress-bar-animation 2s ease-in-out infinite
        background-size 200% auto
        background-position 0 100%
        transition width 0.15s

    .progress-number
        position absolute
        top 0
        left 0
        width 50px
        height 38px
        display flex
        justify-content center
        align-items center
        transform translate(-50%, calc(-100% - 4px))
        animation progress-number-animation 0.35s ease-out infinite alternate
        transition left 0.15s

        svg
            position absolute
            top 0
            left 0
            width 100%
            height 100%

        span
            z-index 2
            font-size 14px
            font-weight 700
            color black

@keyframes progress-bar-animation
    0%
        background-position 0% 100%
    100%
        background-position -200% 100%

@keyframes progress-number-animation
    0%
        transform translate(-50%, calc(-100% - 4px))
    100%
        transform translate(-50%, calc(-100% - 6px))
</style>



// WEBPACK FOOTER //
// src/components/v3/progress/Progress.vue